export function getSchedulePressureColor(pressure: number): string {
  const value = Math.max(0, Math.min(1, pressure))

  if (value <= 0.33) {
    const progress = value / 0.33
    const red = Math.round(34 + progress * (250 - 34))
    const green = Math.round(197 + progress * (204 - 197))
    const blue = Math.round(94 + progress * (21 - 94))
    return `rgb(${red}, ${green}, ${blue})`
  }

  if (value <= 0.66) {
    const progress = (value - 0.33) / 0.33
    const red = Math.round(250 + progress * (249 - 250))
    const green = Math.round(204 + progress * (115 - 204))
    const blue = Math.round(21 + progress * (22 - 21))
    return `rgb(${red}, ${green}, ${blue})`
  }

  const progress = (value - 0.66) / 0.34
  const red = Math.round(249 + progress * (239 - 249))
  const green = Math.round(115 + progress * (68 - 115))
  const blue = Math.round(22 + progress * (68 - 22))
  return `rgb(${red}, ${green}, ${blue})`
}
